import { BRAND_MARK_PATH } from "@previewloop/shared/brand";

/** Inline SVG keeps the widget logo independent of host-page asset URLs. */
export const WORDMARK_HTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="1.4em" height="1.4em" aria-hidden="true" style="flex-shrink:0"><path fill="currentColor" d="${BRAND_MARK_PATH}"/></svg><span>Preview<b>Loop</b></span>`;
